import { reactive } from 'vue';

const sharedState = reactive({
  step: 0,
  title: '',
  description: ''
});

function setStep(value:number, title?:string, description?:string) {    
    sharedState.step = value;
    if (description) {
        sharedState.description = description;
    }
    if (title) {
        sharedState.title = title;
    }
}

function getStep() {
  return sharedState;
}

function updateTitle(title: string) {
  if (title) {
      sharedState.title = title;
  }
}

/** Steps loop Facilita Emprende **/
type LoopState = {
  question2SelectedOptions: any[]; 
  currentLoopStep: number;
};

const loopState: LoopState = {
  question2SelectedOptions: ['q2_opt7'],
  currentLoopStep: 0
};

function setLoopStep(value: number) {
  loopState.currentLoopStep = value;
}

function setLoopState(value: string) {
  // Verify if the value is already in the array to avoid duplicates
  if (!loopState.question2SelectedOptions.includes(value)) {
    loopState.question2SelectedOptions.push(value);
  }

  // Order the array from lowest to highest
  loopState.question2SelectedOptions.sort((a, b) => {
    const numA = parseInt(a.replace('q2_opt', ''), 10);
    const numB = parseInt(b.replace('q2_opt', ''), 10);
    return numA - numB;
  }); 
}

function removeLoopState(value: string) {
  if (value !== 'q2_opt7') {   
    const index = loopState.question2SelectedOptions.indexOf(value);
    if (index !== -1) {
      loopState.question2SelectedOptions.splice(index, 1);
    }
  }
}
function getLoopState() {
  return loopState;
}

function getLoopStep() {
  return loopState.currentLoopStep;
}
/** END - Steps loop Facilita Emprende **/

/** Skip  loop Facilita Emprende **/

type SkipLoopState = {
  [stepId: string]: boolean;
};

const loopSkipService = reactive({
  skipLoopState: {} as SkipLoopState,

  setSkipLoop(stepId: string, value: boolean) {
      this.skipLoopState[stepId] = value;     
  },

  getSkipLoop(stepId: string): boolean {
      return this.skipLoopState[stepId] || false;
  },

  resetSkipLoop(stepId: string) {
      if (this.skipLoopState[stepId] !== undefined) {
          delete this.skipLoopState[stepId];
      }
  },

  resetAllSkipLoop() {
      this.skipLoopState = {} as SkipLoopState;
  }
});
/** END - Skip  loop Facilita Emprende **/

export default {
  sharedState,
  setStep,
  getStep,
  updateTitle,
  loopState,
  setLoopState,
  getLoopState,
  removeLoopState,
  setLoopStep,
  getLoopStep,
  loopSkipService
};
